document.addEventListener("DOMContentLoaded", function () {
	const activeClass = "animated";
	const triggerClass = "animate-on-scroll";
	const scrollTriggers = document.querySelectorAll("[class*='" + triggerClass + "']");

	if (scrollTriggers.length) {
		scrollTriggers.forEach(function (el) {
			addObserver(el);
		});
	}

	function addObserver(el, options) {
		const observer = new IntersectionObserver((entries, observer) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.classList.add(activeClass);
				}
			});
		}, options);

		observer.observe(el);
	}
});
